import { PROCESS_CURRENT_USER_INFO } from '../actions/currentUserActions';
import { PROCESS_EULA } from '../actions/eulaActions';

/**
 * Reducer to update the site language
 * @param {object} state
 * @param {object} action
 */
function currentUser(
  state = { eulaAccepted: false, preferences: { access_level: 0 } },
  action
) {
  switch (action.type) {
    case PROCESS_CURRENT_USER_INFO:
      const payload = action.payload;
      return {
        ...state,
        ...payload,
      };

    case PROCESS_EULA:
      return {
        ...state,
        eulaAccepted: true,
      };
    default:
  }
  return state;
}

export default currentUser;
